import type { DragEvent, MouseEvent } from "react";
import { fmtTimestamp } from "../../lib/dom.js";
import type { Lead } from "../../types.ts";
import { cleanLeadPreviewText } from "../Kanban.helpers.ts";
import { getLeadCentralCampaign } from "./leadCampaign.ts";

export function LeadCard({
  lead,
  selected,
  onSelect,
  onContextMenu,
}: {
  lead: Lead;
  selected: boolean;
  onSelect: () => void;
  onContextMenu: (event: MouseEvent<HTMLElement>) => void;
}) {
  const tags = (lead.issueTags || []).slice(0, 3);
  const previewText = cleanLeadPreviewText(lead.lastMessageText);
  const updatedAtText = fmtTimestamp(lead.updatedAt);
  const centralCampaign = getLeadCentralCampaign(lead);
  return (
    <article
      className={`lead-card ${selected ? "is-selected" : ""}`}
      draggable
      onDragStart={(event: DragEvent<HTMLElement>) => {
        event.dataTransfer.setData("text/x-lead-id", String(lead.id));
        event.dataTransfer.effectAllowed = "move";
      }}
      onClick={onSelect}
      onContextMenu={onContextMenu}
    >
      <header className="lead-head">
        <h3 className="lead-name">{lead.name || "Sem nome"}</h3>
        {lead.priority && lead.priority !== "Media" ? (
          <span className={`lead-priority priority-${String(lead.priority).toLowerCase()}`}>{lead.priority}</span>
        ) : null}
      </header>
      {centralCampaign ? (
        <div className="lead-campaign-line" title={`Campanha Lead Central: ${centralCampaign.label}`}>
          <span className="lead-campaign-label">Campanha</span>
          <span className="lead-campaign-value">{centralCampaign.label}</span>
        </div>
      ) : null}
      {lead.phone ? <div className="lead-line">{lead.phone}</div> : null}
      {lead.course ? <div className="lead-line">{lead.course}</div> : null}
      {previewText ? <div className="lead-snippet">{previewText}</div> : null}
      {tags.length || updatedAtText ? (
        <footer className="lead-foot">
          {tags.length ? (
            <div className="lead-tags">
              {tags.map((tag) => <span key={tag} className="lead-tag">{tag}</span>)}
            </div>
          ) : <span aria-hidden="true" />}
          {updatedAtText ? <time className="lead-date">{updatedAtText}</time> : null}
        </footer>
      ) : null}
    </article>
  );
}
